import { Button } from 'react-bootstrap';
import { LoginCard } from '../../ui';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { contentfulPropTypes } from '../../propTypes';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledH1 = styled.h1`
  font-size: 56px;
  text-align: center;
  color: #fff;
  margin-bottom: 35px;
`;

const StyledH2 = styled.h1`
  font-size: 22px;
  text-align: center;
  color: #fff;
  margin-bottom: 45px;
`;

const StyledReactMarkdown = styled(ReactMarkdown)`
  h1 {
    margin-bottom: 20px;
  }
`;

const StyledButton = styled(Button)`
  margin: 10px 0;
`;

const IntroContainer = ({ contentful, loading, fetched }) => {
  const navigate = useNavigate();

  return (
    !loading &&
    fetched && (
      <div className="d-flex flex-column align-items-center justify-content-center">
        <StyledH1>{contentful.title}</StyledH1>
        <StyledH2>{contentful.subtitle}</StyledH2>
        <LoginCard>
          <StyledReactMarkdown>{contentful?.body}</StyledReactMarkdown>
          <StyledButton onClick={() => navigate('/net-zero/heating')}>
            {contentful.primaryButtonText}
          </StyledButton>
        </LoginCard>
      </div>
    )
  );
};

IntroContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(IntroContainer, 'web_app_netzero_intro_page');
